import { FC, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import './AppleAuthCallback.scss';
import { generalSnackBarAtom } from '../../../data-access';
import { Path } from '../../../routing';
import { useRecoilState } from 'recoil';
import Cookies from 'js-cookie';
import { trackEventMixpanel } from '../../../utils';

const infiniteDays = 365 * 100;

const AppleAuthCallback: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [_, setGeneralSnackbar] = useRecoilState(generalSnackBarAtom);
  const hasProcessed = useRef(false);

  useEffect(() => {
    const processCallback = () => {
      if (hasProcessed.current) return;
      hasProcessed.current = true;

      const userId = searchParams.get('userId');
      const accessToken = searchParams.get('accessToken');
      const refreshToken = searchParams.get('refreshToken');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      if (error) {
        setGeneralSnackbar('Apple Sign In was cancelled or failed. Please try again.');
        navigate('/');
        return;
      }

      if (!userId || !accessToken || !refreshToken) {
        setGeneralSnackbar('Missing authentication information. Please try again.');
        navigate('/');
        return;
      }

      // Parse state to get redirectUrl if available

      // Store tokens in localStorage
      localStorage.setItem('lifestack_access_token', accessToken);
      localStorage.setItem('lifestack_refresh_token', refreshToken);
      localStorage.setItem('lifestack_user_id', userId);
      localStorage.setItem('jwt_configured', 'true');

      // Store in cookies for chrome extension
      Cookies.set('lifestack_user_id', userId, { expires: infiniteDays });
      Cookies.set('lifestack_refresh_token', refreshToken, { expires: infiniteDays });
      Cookies.set('lifestack_access_token', accessToken, { expires: 30 });

      trackEventMixpanel('sign_in_with_apple', {
        userId: userId,
      });

      navigate('/');
    };

    processCallback();
  }, [searchParams, navigate, setGeneralSnackbar]);

  return (
    <div className="apple-auth-callback-page">
      <CircularProgress />
    </div>
  );
};

export default AppleAuthCallback;
